import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
import FormResources    from    '@/components/AssociateComponent/Associates/AdvancedSearch/form_resources'

const Methods = {

    data() {
        return {
            notyf,
        }
    },

    watch: {
        form_data: {
            handler(val)
            {
                let keys = Object.keys(val)
                keys.forEach(item => 
                {
                    this.$refs.main_table.params[item] = val[item]
                });

                this.$refs.main_table.params['page'] = 1;
                // this.fetchMainList(this.$refs.main_table.params)
            },
            deep: true
         },
        
    },


    methods: {
       
       
        returnedAssociatesToParent(withoutChecking = false)
        {
            console.log(withoutChecking)
            if(this.use_parent)
            {
                if(this.parent_associates.length)
                {
                    return {...this.$refs.main_table.returnSelection(), params: this.$refs.main_table.params}
                }
            }
            else
            {
                if(this.associates.length)
                {
                    return {...this.$refs.main_table.returnSelection(), params: this.$refs.main_table.params}
                }
            }
            return null
        },

        selectAllBoxes()
        {
            if(this.associates.length)
            {
                this.associates.map((item) => {
                    item.checked = this.selectAll
                })
            }
        },

        fill_data(data)
        {
            this.$emit('passInitialData', data)

            this.array_options = {
                role_id:                data.roles,
                permissions_template_id: data.permissions_templates,
                reports_to:             data.report_to_associates,
                country_id:             data.countries,
                position_id:            data.positions,
                shift_id:               FormResources.shifts,
                department_id:          data.departments,
                contact_type_id:        data.contact_types,
                status_id:              FormResources.statuses,
                include_in_supervisor_lists: FormResources.include_in_supervisor_lists
            }
        },

        resetList()
        {
            this.$refs.main_table.params['page'] = 1;
            this.fetchMainList(this.$refs.main_table.params)
        }

    },

}

export default Methods